import 'whatwg-fetch';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import startUI from '$src/lib/start-ui/start-ui';
import VueAppHelper, {registerApp} from '$src/lib/VueAppHelper';
import store from '$src/store';
import router, {registerAuthGuard, registerActionGuard} from '$src/router';

Vue.config.productionTip = false;
Vue.use(VueMeta);

(async () => {
    require('$src/scss/main.scss');
    require('$src/lib/start-ui/vendor/redactor/redactor');
    require('$src/components');
    require('$src/components/forms');

    let start = router.beforeEach(async (to, from, next) => {
        await Promise.all([
            store.dispatch('auth/fetchUser'),
            Vue.$api.get('/hydrate', {}).then(data => {
                if (data.$success) {
                    store.commit('auth/setAvailableRoles', data.roles);
                    store.commit('config/setAll', data.config);
                    store.commit('catalog/setAll', data.catalog);
                    store.commit('settings/setSettings', data.settings);
                    store.commit('texts/setTexts', data.texts);
                    store.commit('address/setCities', data.address.cities);
                    store.commit('address/setPostCodes', data.address.post_codes);
                    store.commit('upload/setAllowedFiles', data.upload.allowed_files);
                } else {
                    throw "Hydration failed";
                }
            }),
        ]);
        start();
        await next();
        Vue.$loading('global', false);
    });

    Vue.$auth = Vue.prototype.$auth = {
        isAuth: store.getters['auth/isAuth'],
        isGuest: store.getters['auth/isGuest'],
        isSame: store.getters['auth/isSame'],
    };
    Vue.$can = Vue.prototype.$can = store.getters['auth/hasRight'];
    Vue.$is = Vue.prototype.$is = store.getters['auth/hasRole'];

    Vue.$catalog = Vue.prototype.$catalog = store.getters['catalog/getCatalog'];
    Vue.$select = Vue.prototype.$select = store.getters['catalog/getForSelect'];
    Vue.$img = Vue.prototype.$img = store.getters['upload/getThumbnailUrl'];
    Vue.$file = Vue.prototype.$file = store.getters['upload/getContentUrl'];

    Vue.$config = Vue.prototype.$config = {
        get: store.getters['config/get'],
    };

    Vue.use(startUI, {store, router});
    startUI.enable('env', {
        environments: require('$src/environments').default,
    });
    startUI.enable('api', {
        baseUrl: Vue.$env.api,
    });
    startUI.enable('i18n', {locale: 'de'});
    startUI.enable('moment', {locale: 'de'});
    startUI.enable('ui', {
        titleTemplate: '%s - START Stiftung',
        defaultTitle: 'START Stiftung',
        thousandsSeparator: '.',
    });
    startUI.enable(['modal', 'notify', 'form', 'redactor']);

    Vue.$i18n.set('validation/maxLength', ({max}) => `Dieser Text darf maximal ${max} Zeichen lang sein`, 'de');
    Vue.$i18n.set('validation/minLength', ({min}) => `Dieser Text muss mindestens ${min} Zeichen lang sein`, 'de');
    Vue.$i18n.set('validation/numeric', 'Dieser Wert muss eine Zahl sein.', 'de');
    Vue.$i18n.set('validation/password', 'Das Passwort entspricht nicht den angegebenen Vorgaben.', 'de');

    require('$src/registerServiceWorker');
    require('$src/modals');

    Vue.use(VueAppHelper, {router});
    registerApp('landing', require('$landing/landing').default);
    registerApp('backend', require('$backend/backend').default);

    if (Vue.$env.isCommunity) {
        registerApp('community', require('$community/community').default);
    }
    if (Vue.$env.isApplication) {
        registerApp('application', require('$application/application').default);
    }

    Vue.$loading('global', true);
    registerAuthGuard();
    registerActionGuard();

    let app = new Vue({
        render: h => h(require('$src/App').default),
        router: router,
        store: store,
    });
    if (DEBUG) {
        window.app = app;
    }
    app.$mount('#app');
})();